import VeeValidate from 'assets/js/vee-validate'
import moment from 'moment'

function findDOM (targetField) {
  let field = targetField ? document.querySelector(`input[name='${targetField}']`) : null
  field = (field !== null && field.type === 'radio') ? document.querySelector(`input[name='${targetField}']:checked`) : field
  field = (field === null) ? document.querySelector(`textarea[name='${targetField}']`) : field
  field = (field === null) ? document.querySelector(`select[name='${targetField}']`) : field
  return field
}

function getMessageField (textField) {
  let fields = textField.split('^')
  let getMessageField = ''
  if (fields.length > 1) {
    if (fields.length > 3) {
      getMessageField = fields[0] + ' parent row ' + (parseInt(fields[1]) + 1) + ' child row ' + (parseInt(fields[2]) + 1)
    } else {
      getMessageField = fields[0] + ' row ' + (parseInt(fields[1]) + 1)
    }
  } else {
    getMessageField = fields[0]
  }
  return getMessageField
}

function messageRequiredWhenExist (textReqFields, flgRequired, textWhenFields, flgWhenExist, flgExist = true) {
  return 'This field is required.'
  // let messageReq = ''
  // let concatReq = ''
  // let reqFields = textReqFields.split('-')
  // let verbReq = (reqFields.length > 1) ? ' are ' : ' is '
  // for (let reqField of reqFields) {
  //   let messageReqField = getMessageField(reqField)
  //   messageReq = messageReq + concatReq + messageReqField
  //   concatReq = (flgRequired === 'any') ? ' or ' : ' and '
  // }
  // let suffixWhen = ''
  // let messageWhen = ''
  // let concatWhen = ''
  // let whenFields = textWhenFields.split('-')
  // let verbWhen = (whenFields.length > 1) ? ' are ' : ' is '
  // for (let whenField of whenFields) {
  //   let messageWhenField = getMessageField(whenField)
  //   messageWhen = messageWhen + concatWhen + messageWhenField
  //   concatWhen = (flgWhenExist === 'any') ? ' or ' : ' and '
  // }
  // if (!flgExist) {
  //   suffixWhen = 'not '
  // }
  // return messageReq + verbReq + ' required when ' + messageWhen + verbWhen + suffixWhen + 'exist.'
}

function requiredWhenExist (textReqFields, flgRequired, textWhenFields, flgWhenExist, flgExist = true) {
  if (validateWhenExist(textWhenFields.split('-'), flgWhenExist, flgExist)) {
    return validateRequired(textReqFields.split('-'), flgRequired)
  } else {
    return true
  }
}

function validateWhenExist (targetFields, flg, flgExist) {
  let valid
  if (flg === 'all') {
    valid = true
  } else if (flg === 'any') {
    valid = false
  }
  for (let targetField of targetFields) {
    let field = findDOM(targetField)
    if (field !== null) {
      let validValue = (field.value !== '')
      if (flg === 'all') {
        valid &= (flgExist) ? validValue : !validValue
      } else if (flg === 'any') {
        valid |= (flgExist) ? validValue : !validValue
      }
    }
  }
  return valid
}

function validateRequired (targetFields, flg) {
  let valid = true
  for (let targetField of targetFields) {
    let field = findDOM(targetField)
    if (field !== null) {
      if (flg === 'all') {
        valid &= (field.value !== '')
      } else if (flg === 'any') {
        valid = false
        if (field.value !== '') {
          return true
        }
      }
    }
  }
  return valid
}

VeeValidate.Validator.extend('notDuplicate', {
  getMessage: (field, [targetField]) => {
    return 'This value is duplicated.'
  },
  validate: (value, targetFields) => {
    for (let targetField of targetFields) {
      let field = findDOM(targetField)
      if (field !== null) {
        let fieldValues = field.value.split('-')
        if (value === fieldValues[0].replace(/ /g, '')) {
          return false
        }
      }
    }
    return true
  }
})

VeeValidate.Validator.extend('notMultiDuplicate', {
  getMessage: (field, [targetField]) => {
    return 'Those value are duplicated.'
  },
  validate: (value, [ valueSet, targetFieldSet ]) => {
    let targetFields = targetFieldSet.split('-')
    let values = valueSet.split('-')
    let valueLength = values.length
    let count = 0
    let concat = ''
    let fieldValueSet = ''
    for (let targetField of targetFields) {
      count++
      let field = findDOM(targetField)
      if (field !== null) {
        let fieldValues = field.value.split('-')
        fieldValueSet += concat + fieldValues[0].replace(/ /g, '')
        concat = '-'
      }
      if (count >= valueLength) {
        if (valueSet === fieldValueSet) {
          return false
        }
        count = 0
        concat = ''
        fieldValueSet = ''
      }
    }
    return true
  }
})

VeeValidate.Validator.extend('greaterThan', {
  getMessage: (field, [targetField]) => {
    let fieldDom = findDOM(targetField)
    let targetValue = ''
    if (fieldDom !== null) {
      targetValue = fieldDom.value
    }
    return 'This field must greater than ' + targetValue + '.'
    // return 'This field must greater than ' + getMessageField(targetField) + '.'
  },
  validate: (value, [targetField]) => {
    let field = findDOM(targetField)
    if (field !== null) {
      if (value.split(':').length > 1 && field.value.split(':').length > 1) {
        let valueSplit = value.split(':')
        let fieldValueSplit = field.value.split(':')
        let minValue = parseInt(valueSplit[0]) * 60 + parseInt(valueSplit[1])
        let minFieldValue = parseInt(fieldValueSplit[0]) * 60 + parseInt(fieldValueSplit[1])
        if (isNaN(minValue) || isNaN(minFieldValue)) {
          return true
        } else {
          return minValue > minFieldValue
        }
      } else {
        if (isNaN(value) || isNaN(field.value)) {
          return true
        } else {
          return parseInt(value) > parseInt(field.value)
        }
      }
    }
    return true
  }
})

VeeValidate.Validator.extend('greaterThanOrEqualTo', {
  getMessage: (field, [targetField]) => {
    let fieldDom = findDOM(targetField)
    let targetValue = ''
    if (fieldDom !== null) {
      targetValue = fieldDom.value
    }
    return 'This field must greater than or equal to ' + targetValue + '.'
    // return 'This field must greater than or equal to ' + getMessageField(targetField) + '.'
  },
  validate: (value, [targetField]) => {
    let field = findDOM(targetField)
    if (field !== null) {
      if (value.split(':').length > 1 && field.value.split(':').length > 1) {
        let valueSplit = value.split(':')
        let fieldValueSplit = field.value.split(':')
        let minValue = parseInt(valueSplit[0]) * 60 + parseInt(valueSplit[1])
        let minFieldValue = parseInt(fieldValueSplit[0]) * 60 + parseInt(fieldValueSplit[1])
        if (isNaN(minValue) || isNaN(minFieldValue)) {
          return true
        } else {
          return minValue >= minFieldValue
        }
      } else {
        if (isNaN(value) || isNaN(field.value)) {
          return true
        } else {
          return parseInt(value) >= parseInt(field.value)
        }
      }
    }
    return true
  }
})

VeeValidate.Validator.extend('lessThan', {
  getMessage: (field, [targetField]) => {
    let fieldDom = findDOM(targetField)
    let targetValue = ''
    if (fieldDom !== null) {
      targetValue = fieldDom.value
    }
    return 'This field must less than ' + targetValue + '.'
    // return 'This field must less than ' + getMessageField(targetField) + '.'
  },
  validate: (value, [targetField]) => {
    let field = findDOM(targetField)
    if (field !== null) {
      if (value.split(':').length > 1 && field.value.split(':').length > 1) {
        let valueSplit = value.split(':')
        let fieldValueSplit = field.value.split(':')
        let minValue = parseInt(valueSplit[0]) * 60 + parseInt(valueSplit[1])
        let minFieldValue = parseInt(fieldValueSplit[0]) * 60 + parseInt(fieldValueSplit[1])
        if (isNaN(minValue) || isNaN(minFieldValue)) {
          return true
        } else {
          return minValue < minFieldValue
        }
      } else {
        if (isNaN(value) || isNaN(field.value)) {
          return true
        } else {
          return parseInt(value) < parseInt(field.value)
        }
      }
    }
    return true
  }
})

VeeValidate.Validator.extend('lessThanOrEqualTo', {
  getMessage: (field, [targetField]) => {
    let fieldDom = findDOM(targetField)
    let targetValue = ''
    if (fieldDom !== null) {
      targetValue = fieldDom.value
    }
    return 'This field must less than or equal to ' + targetValue + '.'
    // return 'This field must less than or equal to ' + getMessageField(targetField) + '.'
  },
  validate: (value, [targetField]) => {
    let field = findDOM(targetField)
    if (field !== null) {
      if (value.split(':').length > 1 && field.value.split(':').length > 1) {
        let valueSplit = value.split(':')
        let fieldValueSplit = field.value.split(':')
        let minValue = parseInt(valueSplit[0]) * 60 + parseInt(valueSplit[1])
        let minFieldValue = parseInt(fieldValueSplit[0]) * 60 + parseInt(fieldValueSplit[1])
        if (isNaN(minValue) || isNaN(minFieldValue)) {
          return true
        } else {
          return minValue <= minFieldValue
        }
      } else {
        if (isNaN(value) || isNaN(field.value)) {
          return true
        } else {
          return parseInt(value) <= parseInt(field.value)
        }
      }
    }
    return true
  }
})

VeeValidate.Validator.extend('notBetween', {
  getMessage: (field, pairFields) => {
    let message = ''
    let concatPair = ''
    for (var pairField of pairFields) {
      let targetFields = pairField.split('-')
      let concatTarget = ''
      let messageTarget = ''
      for (var targetField of targetFields) {
        let fieldDom = findDOM(targetField)
        let targetValue = ''
        if (fieldDom !== null) {
          targetValue = fieldDom.value
        }
        messageTarget = messageTarget + concatTarget + targetValue
        // messageTarget = messageTarget + concatTarget + getMessageField(targetField)
        concatTarget = ' and '
      }
      message = message + concatPair + ' (' + messageTarget + ') '
      concatPair = ' or '
    }
    return 'This field must not be between ' + message + '.'
  },
  validate: (value, pairFields) => {
    let arrPairField = []
    for (var pairField of pairFields) {
      let arrField = []
      let targetFields = pairField.split('-')
      for (var targetField of targetFields) {
        let field = findDOM(targetField)
        arrField.push(field)
      }
      arrPairField.push(arrField)
    }
    for (var arrField of arrPairField) {
      if (arrField[0] !== null && arrField[1] !== null) {
        if (!isNaN(arrField[0].value) && !isNaN(arrField[1].value)) {
          if (parseInt(value) >= parseInt(arrField[0].value) && parseInt(value) <= parseInt(arrField[1].value)) {
            return false
          }
        }
      }
    }
    return true
  }
})

VeeValidate.Validator.extend('isSameMonth', {
  getMessage: (field, pairFields) => {
    return 'This field must in the same month.'
  },
  validate: (value, [targetField]) => {
    let field = targetField ? document.querySelector(`input[name='${targetField}']`) : null
    if (field !== null) {
      return moment(moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')).isSame(moment(field.value, 'DD/MM/YYYY').format('YYYY-MM-DD'), 'month')
    }
    return true
  }
})

VeeValidate.Validator.extend('requiredWhenExist', {
  getMessage: (field, [targetField]) => {
    return 'This field is required.'
  },
  validate: (value, [targetField]) => {
    let field = findDOM(targetField)
    if (field !== null) {
      return !(value === '' && field.value !== '')
    }
    return true
  }
})
VeeValidate.Validator.extend('requiredWhenNotExist', {
  getMessage: (field, targetFields) => {
    return 'This field is required.'
  },
  validate: (value, targetFields) => {
    let valid = false
    for (var targetField of targetFields) {
      let field = findDOM(targetField)
      if (field !== null) {
        if (!(value === '' && field.value === '')) {
          valid = true
        }
      } else {
        valid = true
      }
    }
    return valid
  }
})
VeeValidate.Validator.extend('requiredAny', {
  getMessage: (field, targetFields) => {
    return 'This field is required any.'
  },
  validate: (value, targetFields) => {
    for (var targetField of targetFields) {
      let field = findDOM(targetField)
      if (field !== null) {
        if (field.value !== '') {
          return true
        }
      }
    }
    return false
  }
})
VeeValidate.Validator.extend('requiredAllWhenExistAll', {
  getMessage: (field, [ textReqFields, textWhenFields ]) => {
    return messageRequiredWhenExist(textReqFields, 'all', textWhenFields, 'all')
  },
  validate: (value, [ textReqFields, textWhenFields ]) => {
    return requiredWhenExist(textReqFields, 'all', textWhenFields, 'all')
  }
})
VeeValidate.Validator.extend('requiredAllWhenExistAny', {
  getMessage: (field, [ textReqFields, textWhenFields ]) => {
    return messageRequiredWhenExist(textReqFields, 'all', textWhenFields, 'any')
  },
  validate: (value, [ textReqFields, textWhenFields ]) => {
    return requiredWhenExist(textReqFields, 'all', textWhenFields, 'any')
  }
})
VeeValidate.Validator.extend('requiredAllWhenNotExistAll', {
  getMessage: (field, [ textReqFields, textWhenFields ]) => {
    return messageRequiredWhenExist(textReqFields, 'all', textWhenFields, 'all', false)
  },
  validate: (value, [ textReqFields, textWhenFields ]) => {
    return requiredWhenExist(textReqFields, 'all', textWhenFields, 'all', false)
  }
})
VeeValidate.Validator.extend('requiredAllWhenNotExistAny', {
  getMessage: (field, [ textReqFields, textWhenFields ]) => {
    return messageRequiredWhenExist(textReqFields, 'all', textWhenFields, 'any', false)
  },
  validate: (value, [ textReqFields, textWhenFields ]) => {
    return requiredWhenExist(textReqFields, 'all', textWhenFields, 'any', false)
  }
})
VeeValidate.Validator.extend('requiredAnyWhenExistAll', {
  getMessage: (field, [ textReqFields, textWhenFields ]) => {
    return messageRequiredWhenExist(textReqFields, 'any', textWhenFields, 'all')
  },
  validate: (value, [ textReqFields, textWhenFields ]) => {
    return requiredWhenExist(textReqFields, 'any', textWhenFields, 'all')
  }
})
VeeValidate.Validator.extend('requiredAnyWhenExistAny', {
  getMessage: (field, [ textReqFields, textWhenFields ]) => {
    return messageRequiredWhenExist(textReqFields, 'any', textWhenFields, 'any')
  },
  validate: (value, [ textReqFields, textWhenFields ]) => {
    return requiredWhenExist(textReqFields, 'any', textWhenFields, 'any')
  }
})
VeeValidate.Validator.extend('requiredAnyWhenNotExistAll', {
  getMessage: (field, [ textReqFields, textWhenFields ]) => {
    return messageRequiredWhenExist(textReqFields, 'any', textWhenFields, 'all', false)
  },
  validate: (value, [ textReqFields, textWhenFields ]) => {
    return requiredWhenExist(textReqFields, 'any', textWhenFields, 'all', false)
  }
})
VeeValidate.Validator.extend('requiredAnyWhenNotExistAny', {
  getMessage: (field, [ textReqFields, textWhenFields ]) => {
    return messageRequiredWhenExist(textReqFields, 'any', textWhenFields, 'any', false)
  },
  validate: (value, [ textReqFields, textWhenFields ]) => {
    return requiredWhenExist(textReqFields, 'any', textWhenFields, 'any', false)
  }
})
VeeValidate.Validator.extend('requiredIf', {
  getMessage: (field, [ targetField, targetValue ]) => {
    return 'This field is required when ' + getMessageField(targetField) + ' has value ' + targetValue + '.'
  },
  validate: (value, [ targetField, targetValue ]) => {
    let field = findDOM(targetField)
    if (field !== null) {
      return (value) || (field.value !== targetValue)
    }
    return true
  }
})

VeeValidate.Validator.installDateTimeValidators(moment)

export default VeeValidate



// WEBPACK FOOTER //
// ./src/veeValidate.js